// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notice-popover {\n  width: 356px;\n}\n.notice-popover[x-placement^=bottom] {\n  margin-top: -8px;\n}", ""]);
// Exports
module.exports = exports;
